module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inputer-container",
    class: [_vm.fullscreen ? 'fullscreen' : '', _vm.preview ? 'preview' : '', _vm.theme]
  }, [_c('div', {
    staticClass: "inputer-content"
  }, [_c('textarea', {
    attrs: {
      "id": "inputer",
      "autofocus": ""
    },
    domProps: {
      "value": _vm.rawTxt
    },
    on: {
      "input": _vm.inputting,
      "scroll": _vm.syncStroll,
      "drop": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.dragging($event)
      }
    }
  }), _vm._v(" "), _c('line-number')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ca467a","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inputer.vue
// module id = 356
// module chunks = 0